let shopifyLocale = Shopify.locale.split("-")[0];
let localeCountry = `${shopifyLocale}-${Shopify.country}`;
const shopCurrency = Shopify.currency.active;
function currencyES6Format(money) {
  const formatted = new Intl.NumberFormat(localeCountry, {
    style: "currency",
    currency: shopCurrency,
  }).format(money);

  // Add a space between symbol and number if missing
  return formatted.replace(/(\D)(\d)/, "$1 $2");
}

var hostname = window.location.hostname;
// var hostname = "theherbalchemist.com";
var link = `https://${hostname}/cart.json`;

async function getData() {
  let x = await fetch(link);
  const data = await x.json();
  return data;
}
var dropdowncart = () => {
  $(".checkout_btn").text("Place Order");
  $("#cart_drawer").addClass("loader");
  // $('.custom-cart-error').remove()
  getData().then((data) => {
    console.log(data, "bssssvsssssssssssss");
    $("#cart_drawer").removeClass("loader");
    var item_count = data["item_count"];
    var total_price = data["total_price"] / 100;
    var product_count = data["items"].length;
    //console.log(data["items"]);
    $(".custom_cart_count").html(item_count);
    $(".site-header-cart--count").attr("data-header-cart-count", item_count);
    if (item_count > 0) {
      $(".minitotal.total,.sd_sidebar_check").show();
      $("#productbox").find("div").remove();
      // $("#productbox").html(
      //   $('<h3 class="heading" id="cart_item_count"></h3>')
      // );
      for (var i = 0; i < product_count; i++) {
        var item_id = data["items"][i]["id"];
        var product_title = data["items"][i]["product_title"];
        var product_handle = data["items"][i]["handle"];
        var quantity = data["items"][i]["quantity"];
        var line_price = data["items"][i]["price"] / 100;
        var cutoff_price = data["items"][i]["original_price"] / 100;
        var url = data["items"][i]["url"];
        var image_url = data["items"][i]["image"];
        var variants = data["items"][i]["variant_options"];
        var product_key = data["items"][i]["key"];
        //console.log(variants);
        var variant_title = data["items"][i]["variant_title"];
        //console.log(variant_title);
        if (variant_title == null) {
          variant_title = "";
        }

        $("#cart_item_count").text(+item_count + " Items in your cart");
        $("#mini_cart_total").text(currencyES6Format(total_price.toFixed(2)));
        $("#productbox").append(
          $(
            '<div class="product-inner row mini-cart-product" id="' +
              item_id +
              '">' +
              '<div class="product_image image">' +
              '<a href="javascript:void(0);">' +
              '<img src="' +
              image_url +
              '" alt="' +
              product_title +
              '">' +
              "</a>" +
              "</div>" +
              '<div class="pro-content" id="pro-content">' +
              '<div class="cartproname prohead">' +
              '<a href="' +
              url +
              ' id="product_head">' +
              product_title +
              "</a>" +
              '<div class="prd_variant_style">' +
              variant_title +
              "</div>" +
              "</div>" +
              '<div class="price-section">' +
              '<span class="price product_price" id="product_price">' +
              currencyES6Format(line_price.toFixed(2)) +
              "</span>" +
              "</div>" +
              '<div class="pro-quantity">' +
              '<div class="quantity-selector">' +
              '<div class="quantitybox">' +
              '<button type="button" class="sd_altera sminus" rel="' +
              i +
              '">-</button>' +
              '<input type="text" readonly id="updatequant" name="updatequant" value="' +
              quantity +
              '" proid="' +
              item_id +
              '" prokey="' +
              i +
              '">' +
              '<button type="button" class="sd_altera splus down">+</button>' +
              "</div>" +
              "</div>" +
              "</div>" +
              '<div class="remove-section">' +
              '<p class="removeproduct remove" id="' +
              product_key +
              '" rel="' +
              i +
              '">Remove</p>' +
              "</div>" +
              "</div>" +
              "</div>"
          )
        );
      }
      $(".cart-dis-txt").show();
      $(".remove").on("click", function remove_item() {
        let product_id = this.id;
        $(this).parents(".product-inner").remove();
        removecart(product_id);
      });
      $(".splus").on("click", function () {
        var upinput = $(this).parents(".quantitybox").find("input").val();
        var inc = parseInt(upinput) + 1;
        $(this).parents(".quantitybox").find("input").val(inc);
        var inc_id = $(this)
          .parents(".quantitybox")
          .find("input")
          .attr("proid");
        incr_cart(inc_id, inc);
      });
      $(".sminus").on("click", function () {
        var upinput = $(this).parents(".quantitybox").find("input").val();
        var dec = parseInt(upinput) - 1;
        var dec_id = $(this)
          .parents(".quantitybox")
          .find("input")
          .attr("proid");
        $(this).parents(".quantitybox").find("input").val(dec);
        dec_cart(dec_id, dec);
      });
    } else {
      $(".cart-dis-txt").hide();

      // You can manage these values dynamically
      const emptyCartImage =
        window.shopSettings?.empty_cart_image ||
        "https://cdn.shopify.com/s/files/1/0832/8521/3505/files/empty-cart.webp?v=1698652243";
      const emptyCartText =
        window.shopSettings?.empty_cart_text || "Your cart is empty.";
      const shopUrl = window.shopSettings?.shop_url || "/collections/all";

      const emptyCartHTML = `
    <div class="cart-item-container">
      <div class="media-body empty-media">
        <figure>
          <img src="${emptyCartImage}" alt="empty-cart" loading="lazy">
        </figure>
        <h3 class="row mini-cart-product">${emptyCartText}</h3>
      </div>
      <div class="bottom-cart-box">
        <div class="cart-btn-container">
          <a href="${shopUrl}" class="primary-btn cont-shopping sd_shopproduct" style="display:block;">
            Continue Shopping
          </a>
        </div>
      </div>
    </div>`;

      $("#productbox").html($(emptyCartHTML));
      $(".minitotal.total,.sd_sidebar_check").hide();
    }
  });
};

var addToCart = (form) => {
  // $.post('/cart/add.js', $(form).serialize()).fail(function(error) {
  //   var errorText = JSON.parse(error.responseText);
  //   console.log(errorText);
  //   dropdowncart();
  //   // $('.custom-cart-error').remove();
  //   // $('.custom-cart .product-outer').prepend('<p class="custom-cart-error">' + errorText.description + '</p>');
  // }).then(function(){
  //   dropdowncart();
  // });
  setTimeout(function () {
    dropdowncart();
  }, 500);
};

//custom cart
//$('form[action="/cart/add"]').on('submit',function(e){
$(document).on("submit", 'form[action="/cart/add"]', function (e) {
  addToCart(this);
  e.preventDefault();
  e.stopPropagation();
  $("#cart_drawer").addClass("active");
  $("html, body").css({
    overflow: "hidden",
  });
});

// setTimeout(function () {

// var addtocart = document.querySelectorAll('button.productitem--action-trigger.productitem--action-atc.button-primary.mdc-ripple-surface.mdc-ripple-upgraded');
// 0
// var removeClick = () => { };

// for (let i = 0; i < addtocart.length; i++) {
//   addtocart[i].removeEventListener("click", removeClick);
// }
$(
  "button.productitem--action-trigger.productitem--action-atc.button-primary.mdc-ripple-surface.mdc-ripple-upgraded"
).off("click");

//,function () {
$(document).on("click", ".atc--button", function (e) {
  //.atc--button,.productitem--action-atc
  $(".modal--quickshop-full .modal-close").click();
  // Do something with $(this).
  let cart = {
    id: $(this).data("variant-id"),
    quantity: 1,
  };
  //console.log(cart);
  $.post("/cart/add.js", cart)
    .fail(function (error) {
      var errorText = JSON.parse(error.responseText);
      //console.log(errorText);
      dropdowncart();
      $("#cart_drawer").addClass("active");
    })
    .then(function () {
      //console.log("in then");
      $(".modal--quickshop-slim .modal-close").trigger("click");
      dropdowncart();
      $("#cart_drawer").addClass("active");
    });
  e.preventDefault();
  e.stopPropagation();
});
// },100);

var update_header_cart = () => {
  getData().then((data) => {
    var item_count = data["item_count"];
    $(".custom_cart_count").html(item_count);
  });
};
update_header_cart();

$(".site-header-cart--button").on("click", function (e) {
  e.preventDefault();
  dropdowncart();
  $("#cart_drawer").addClass("active");
  $("html,body").css({
    overflow: "hidden",
  });
});

var incr_cart = (proid, inc) => {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      id: parseFloat(proid),
      quantity: inc,
    },
  }).then((data) => {
    dropdowncart();
  });
};
var dec_cart = (proid, dec) => {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      id: parseFloat(proid),
      quantity: dec,
    },
  }).then((data) => {
    dropdowncart();
  });
};

var removecart = (new_id) => {
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      id: parseFloat(new_id),
      quantity: 0,
    },
  }).then((data) => {
    dropdowncart();
  });
};
$(document).on("click", ".sides_cross_image", function (e) {
  $("#cart_drawer").removeClass("active");
  $("html,body").css({
    overflow: "visible",
  });
});
